export default __webpack_public_path__ + "static/media/tenstbetterwtable.f1cb38cd.webp";